export const buildRegisterUserPayload = (formData) => {
    return {
        customerName:formData.customerName,
        commerceName: formData.commerceName,
        lastName: formData.lastName,
        lastName2: formData.lastName2,
        email: formData.email,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        address: formData.address,
        phone: formData.phone,
        ine: formData.ine,
        ineback:formData.ineback,
        face: formData.face,
        clabe: formData.clabe,
        proofOfAddress: formData.proofOfAddress
    };
};